/* cart-accessories v2.2 · Bruno · 06.10.2026 (גיבוי לחיצי גלילה) — אחרי הוספה הסל נשאר באותו מקום והפס נשאר מול העיניים */
(function () {
  if (window.__cartAccessories) return;
  window.__cartAccessories = true;

  // ---------- חיצי גלילה (דסקטופ) ----------
  // RTL: scrollLeft מתחיל ב-0 ויורד לשלילי כשגוללים "קדימה" (שמאלה).
  function updateNav(section) {
    var list = section.querySelector('.cart-acc__list');
    var prev = section.querySelector('[data-acc-nav="prev"]');
    var next = section.querySelector('[data-acc-nav="next"]');
    if (!list || !prev || !next) return;
    var max = list.scrollWidth - list.clientWidth;
    var pos = Math.abs(list.scrollLeft);
    prev.hidden = pos <= 2;
    next.hidden = max <= 2 || pos >= max - 2;
  }

  function updateAll() {
    document.querySelectorAll('.cart-acc').forEach(updateNav);
  }

  document.addEventListener('scroll', function (ev) {
    var t = ev.target;
    if (t && t.classList && t.classList.contains('cart-acc__list')) updateNav(t.closest('.cart-acc'));
  }, true);

  window.addEventListener('resize', updateAll);

  // הסל נבנה מחדש אחרי כל שינוי — מעדכנים את החיצים כשהפס מופיע/משתנה.
  function watch() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.__accObserved) return;
    drawer.__accObserved = true;
    new MutationObserver(function () { requestAnimationFrame(updateAll); })
      .observe(drawer, { childList: true, subtree: true });
    drawer.addEventListener('transitionend', updateAll);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { watch(); updateAll(); });
  else { watch(); updateAll(); }

  // ---------- שמירת מיקום ----------
  // renderContents בונה את הסל מחדש וגולל אותו לראש — הפס נדחק מתחת למסך ונראה כאילו נעלם.
  // לכן מודדים איפה הפס עמד על המסך לפני ההוספה, ומחזירים אותו בדיוק לשם אחרי הבנייה מחדש.
  function scroller() {
    var acc = document.querySelector('cart-drawer .cart-acc');
    var el = acc && acc.parentElement;
    while (el && el !== document.body) {
      var oy = getComputedStyle(el).overflowY;
      if ((oy === 'auto' || oy === 'scroll') && el.scrollHeight > el.clientHeight) return el;
      el = el.parentElement;
    }
    return null;
  }
  function keepStripInPlace(anchorTop) {
    var until = Date.now() + 600; // גם אחרי open()/focus של התבנית, שיכולים לגלול שוב
    (function fix() {
      var acc = document.querySelector('cart-drawer .cart-acc');
      var sc = scroller();
      if (acc && sc) {
        var diff = acc.getBoundingClientRect().top - anchorTop;
        if (Math.abs(diff) > 1) sc.scrollTo({ top: sc.scrollTop + diff, behavior: 'instant' });
      }
      if (Date.now() < until) requestAnimationFrame(fix);
    })();
  }

  // ---------- לחיצות ----------
  function showError(section, msg) {
    var e = section && section.querySelector('.cart-acc__error');
    if (!e) return;
    e.textContent = msg;
    e.hidden = false;
  }

  document.addEventListener('click', function (ev) {
    var nav = ev.target.closest && ev.target.closest('[data-acc-nav]');
    if (nav) {
      ev.preventDefault();
      var sec = nav.closest('.cart-acc');
      var list = sec.querySelector('.cart-acc__list');
      var step = list.clientWidth * 0.8;
      var dir = nav.getAttribute('data-acc-nav') === 'next' ? -1 : 1; // RTL
      var from = list.scrollLeft;
      list.scrollBy({ left: dir * step, behavior: 'smooth' });
      // גיבוי: אם הגלילה החלקה לא זזה (טאב ברקע / ספארי ישן) — קפיצה מיידית
      setTimeout(function () {
        if (Math.abs(list.scrollLeft - from) < 2) list.scrollTo({ left: from + dir * step, behavior: 'instant' });
        updateNav(sec);
      }, 350);
      setTimeout(function () { updateNav(sec); }, 800);
      return;
    }

    var btn = ev.target.closest && ev.target.closest('[data-acc-add]');
    if (!btn || btn.disabled) return;
    ev.preventDefault();
    var section = btn.closest('.cart-acc');
    var drawer = document.querySelector('cart-drawer');
    var anchorTop = section.getBoundingClientRect().top;
    btn.disabled = true;
    var label = btn.textContent;
    btn.textContent = 'מוסיפה…';

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(btn.getAttribute('data-acc-add')), quantity: 1, properties: { _upsell: 'cart-accessories' } }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok || res.body.status) {
          throw new Error(res.body.description || res.body.message || 'error');
        }
        if (drawer && typeof drawer.renderContents === 'function' && res.body.sections) {
          drawer.renderContents(res.body);
          keepStripInPlace(anchorTop);
        } else {
          window.location.reload();
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = label;
        showError(section, 'לא הצלחנו להוסיף את הפריט. נסי שוב.');
      });
  });
})();